import React, { useState } from 'react';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import { LoadingIndicator } from '@ygtechnologies/bygr-frontend-component-library';
import { cancelProfileInvite, getProfileAcl } from '@/services/profiles';
import ProfilePermissionsEditDialog from '@/components/profile/ProfilePermissionsEditDialog';
import ProfileMemberPermissionsList from '@/components/profile/ProfileMemberPermissionsList';
import { faUserPlus } from '@fortawesome/pro-light-svg-icons';
import { InternalLinkButton, ButtonBar } from '@/components/Buttons';
import { IState } from '@/state/IState';
import { useAsyncState } from '@/utils/hooks';
import { useSelector } from 'react-redux';
import { ProfileMemberDetails } from '@/types';
import { PageTitle, SimplePageTitle } from '@/components/layout/PageTitle';

interface ProfileUserManagementProps {}

interface EditInfo {
    memberDetails: ProfileMemberDetails;
    editType: 'permissions';
}

const ProfileUserManagement: React.FC<ProfileUserManagementProps> = () => {
    const profile = useSelector((state: IState) => state.global.activeProfile!);
    const [members, , reloadMembers] = useAsyncState(() => getProfileAcl(profile.id), [profile], null);
    const [editInfo, setEditInfo] = useState<EditInfo | null>(null);

    const handleCancelInviteClick = (permissionSet) => {
        cancelProfileInvite(permissionSet.inviteId).then((result) => {
            reloadMembers();
        });
    };

    const handleEditClick = (member: ProfileMemberDetails) => {
        setEditInfo({
            editType: 'permissions',
            memberDetails: member,
        });
    };

    const handleEditDialogClose = () => {
        setEditInfo(null);
    };

    const handleEditDialogAccept = () => {
        reloadMembers();
    };

    if (!profile || !members) {
        return <LoadingIndicator />;
    }
    
    const profileName = profile.name;

    return (
        <div>
            <SimplePageTitle title={t`${profileName} users and permissions`} />

            <ButtonBar>
                <InternalLinkButton to="/profile-users/invite" color="tertiary" icon={faUserPlus}>
                    <Trans>Invite a user</Trans>
                </InternalLinkButton>
            </ButtonBar>

            <ProfilePermissionsEditDialog
                show={!!editInfo}
                memberDetails={editInfo ? editInfo.memberDetails : null}
                onClose={handleEditDialogClose}
                onAccept={handleEditDialogAccept}
            />

            <ProfileMemberPermissionsList
                members={members}
                onEditPermissionsClick={handleEditClick}
                onCancelInviteClick={handleCancelInviteClick}
            />
        </div>
    );
};

export default ProfileUserManagement;